<template>
  <div class="column is-4">
    <div class="field">
      <label class="label is-small has-text-white">Search by State<span class="has-text-dark">Search by State Search by State</span></label>
      <div
        class="dropdown is-fullwidth"
        :class="{'is-active': show}"
        @click="showState()"
      >
        <div class="dropdown-trigger is-fullwidth">
          <button
            class="button is-fullwidth"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
          >
            <span v-if="!currentState">Select your state ...</span>
            <span
              v-if="!currentState"
              class="icon is-small"
            >
              <i
                class="far fa-angle-down"
                aria-hidden="true"
              />
            </span>
            <span v-if="currentState">{{ currentState.name }}</span>
          </button>
        </div>
        <div class="dropdown-menu is-fullwidth">
          <div class="dropdown-content">
            <a
              v-for="state in states"
              class="dropdown-item"
              style="color: #666;"
              @click="selectState(state)"
            >{{ state.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StateSelector',
    data () {
      return {
        currentState: '',
        show: false,
        states: [
          {
            name: 'Alabama',
            id: 'AL'
          },
          {
            name: 'Alaska',
            id: 'AK'
          },
          {
            name: 'Arkansas',
            id: 'AR'
          },
          {
            name: 'California',
            id: 'CA'
          },
          {
            name: 'Colorado',
            id: 'CO'
          },
          {
            name: 'Connecticut',
            id: 'CT'
          },
          {
            name: 'District of Columbia',
            id: 'DC'
          },
          {
            name: 'Delaware',
            id: 'DE'
          },
          {
            name: 'Florida',
            id: 'FL'
          },
          {
            name: 'Georgia',
            id: 'GA'
          },
          {
            name: 'Hawaii',
            id: 'HI'
          },
          {
            name: 'Idaho',
            id: 'ID'
          },
          {
            name: 'Illinois',
            id: 'IL'
          },
          {
            name: 'Indiana',
            id: 'IN'
          },
          {
            name: 'Iowa',
            id: 'IA'
          },
          {
            name: 'Kansas',
            id: 'KS'
          },
          {
            name: 'Kentucky',
            id: 'KY'
          },
          {
            name: 'Louisiana',
            id: 'LA'
          },
          {
            name: 'Maine',
            id: 'ME'
          },
          {
            name: 'Maryland',
            id: 'MD'
          },
          {
            name: 'Massachusetts',
            id: 'MA'
          },
          {
            name: 'Michigan',
            id: 'MI'
          },
          {
            name: 'Minnesota',
            id: 'MN'
          },
          {
            name: 'Mississippi',
            id: 'MS'
          },
          {
            name: 'Missouri',
            id: 'MO'
          },
          {
            name: 'Montana',
            id: 'MT'
          },
          {
            name: 'Nebraska',
            id: 'NE'
          },
          {
            name: 'Nevada',
            id: 'NV'
          },
          {
            name: 'New Hampshire',
            id: 'NH'
          },
          {
            name: 'New Jersey',
            id: 'NJ'
          },
          {
            name: 'New Mexico',
            id: 'NM'
          },
          {
            name: 'New York',
            id: 'NY'
          },
          {
            name: 'Ohio',
            id: 'OH'
          },
          {
            name: 'Oklahoma',
            id: 'OK'
          },
          {
            name: 'Oregon',
            id: 'OR'
          },
          {
            name: 'North Carolina',
            id: 'NC'
          },
          {
            name: 'North Dakota',
            id: 'ND'
          },
          {
            name: 'Pennsylvania',
            id: 'PA'
          },
          {
            name: 'Rhode Island',
            id: 'RI'
          },
          {
            name: 'South Carolina',
            id: 'SC'
          },
          {
            name: 'South Dakota',
            id: 'SD'
          },
          {
            name: 'Tennessee',
            id: 'TN'
          },
          {
            name: 'Texas',
            id: 'TX'
          },
          {
            name: 'Utah',
            id: 'UT'
          },
          {
            name: 'Vermont',
            id: 'VT'
          },
          {
            name: 'Virginia',
            id: 'VA'
          },
          {
            name: 'Washington',
            id: 'WA'
          },
          {
            name: 'West Virginia',
            id: 'WV'
          },
          {
            name: 'Wisconsin',
            id: 'WI'
          },
          {
            name: 'Wyoming',
            id: 'WY'
          }
        ]
      }
    },
    methods: {
      selectState (state) {
        this.currentState = state
        this.$emit('selectState', this.currentState.id)
      },
      showState () {
        this.show = !this.show
      }
    }
  }
</script>
